export const AGENT_VIEWER_ROLE_ID = '651736d57a0cb20606f2ddd1';
export const AGENT_VIEWER_ROLE_NAME = 'Agente';
export const CLIENT_ROLE_NAME = 'Cliente';
